(function () {
  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function getVariantFromOptions(product, selectedOptions) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });
  }

  function mediaUrlFromVariant(product, variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src;
    }
    if (variant.featured_image) {
      return variant.featured_image.src || variant.featured_image;
    }
    // Match media by id
    if (variant.featured_media && variant.featured_media.id && product.media) {
      var m = product.media.find(function (med) {
        return med.id === variant.featured_media.id;
      });
      if (m) return m.src || (m.preview_image && m.preview_image.src);
    }
    return null;
  }

  function updateImage(section, src, alt, mediaId) {
    var img = section.querySelector('[data-product-image]');
    if (img && src) {
      // Shopify CDN: request a reasonable width
      var url = src;
      if (src.indexOf('cdn.shopify.com') !== -1 && src.indexOf('&width=') === -1 && src.indexOf('?width=') === -1) {
        url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1400';
      }
      img.src = url;
      if (alt) img.alt = alt;
    }
    section.querySelectorAll('[data-media-id]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', mediaId && String(thumb.getAttribute('data-media-id')) === String(mediaId));
    });
  }

  function initProductSection(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var form = section.querySelector('.product-form') || section.querySelector('form[action*="/cart/add"]');
    var variantInput = section.querySelector('[data-product-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var selects = section.querySelectorAll('[data-option-select]');

    function currentOptions() {
      var opts = [];
      selects.forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        opts[idx] = sel.value;
      });
      return opts;
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = money(variant.price, (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD');
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      var src = mediaUrlFromVariant(product, variant);
      var mediaId = variant.featured_media && variant.featured_media.id;
      if (src) {
        updateImage(section, src, product.title, mediaId);
      }

      // Update selected option labels
      variant.options.forEach(function (val, i) {
        var label = section.querySelector('[data-selected-option-' + i + ']');
        if (label) label.textContent = val;
      });
    }

    function onOptionChange() {
      var opts = currentOptions();
      var variant = getVariantFromOptions(product, opts);
      applyVariant(variant);
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', onOptionChange);
    });

    // Color swatches
    section.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var index = swatch.getAttribute('data-option-index');
        var value = swatch.getAttribute('data-option-value');
        var select = section.querySelector('[data-option-select][data-option-index="' + index + '"]');
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        section.querySelectorAll('.swatch[data-option-index="' + index + '"]').forEach(function (s) {
          var on = s.getAttribute('data-option-value') === value;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      });
    });

    // Thumbnail clicks
    section.querySelectorAll('[data-media-src]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        updateImage(
          section,
          thumb.getAttribute('data-media-src'),
          thumb.getAttribute('data-media-alt'),
          thumb.getAttribute('data-media-id')
        );
      });
    });

    // Initial sync
    onOptionChange();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProductSection);
  });
})();
